import React, {useState} from "react";
import { Footer } from "../GlobalComponent/Footer";
import { Header } from "./Header";
import { Left } from "./Left";
import { Popup } from "../GlobalComponent/Popup";
import { Preloader } from "../GlobalComponent/Preloader";

type AdminLayoutProps = {
	children: React.ReactNode;
};

export const AdminLayout = ({ children }: AdminLayoutProps) => {

	const [isOpen, setIsOpen] = useState(false);

	const handleOpenCloseLeft = () => {
		console.log(isOpen)

		if(isOpen){
			setIsOpen(false)
		}
		else{
			setIsOpen(true)
		}
		
	}

	return (
		<React.Fragment>
			<Preloader></Preloader>
			<Left isOpen={isOpen} handleOpenCloseLeft={handleOpenCloseLeft} ></Left>
			<Popup></Popup>
			<div className="metaportal_fn_main">
				<Header handleOpenCloseLeft={handleOpenCloseLeft}></Header>
				<div className="metaportal_fn_content">
					{children}
					<Footer></Footer>
				</div>
			</div>
		</React.Fragment>


	);
};
